import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { T } from '../Auth/Util'
import track from '../assets/track.png'



const GetStarted = () => {
  return (
    <div>
      <Header />
        <section class="max-w-6xl mx-auto px-6 md:px-10 pt-20 pb-16">
          <div class="max-w-2xl">
            <h1 class="font-display font-semibold text-3xl md:text-4xl mt-12 leading-tight">
              Glad to have you, <span style={{color:"blue"}}> Onboard</span>
            </h1>
          </div>

          <div class="grid md:grid-cols-3 mt-14 border-t" style={{borderColor:""}}>
          
            <div class="ledger-row py-8 md:pr-8 md:border-r" style={{borderColor:""}}>
              <div class="flex items-center gap-3">
                <span class="num-chip w-8 h-8 rounded-full border flex items-center justify-center shrink-0" style={{borderColor:T.themeblue,color:T.buttonColor}}>01</span>
                <h3 class="font-display font-semibold text-lg">Download the App</h3>
              </div>
              <p class="mt-3 text-sm leading-relaxed text-slate-600">Launch the App Store on iOS or Google Play Store, Type beeppee into the search bar and install.</p>
            </div>

            <div class="ledger-row py-8 md:px-8 md:border-r" style={{borderColor:""}}>
              <div class="flex items-center gap-3">
                <span class="num-chip w-8 h-8 rounded-full border flex items-center justify-center shrink-0" style={{borderColor:T.themeblue,color:T.buttonColor}}>02</span>
                <h3 class="font-display font-semibold text-lg">Create Your Account</h3>
              </div>
              <p class="mt-3 text-sm leading-relaxed text-slate-600">Launch the application on your mobile device, Sign up fill in your name, email, active phone number, and choose a secured password, Check your email inbox for a verification code to activate.</p>
            </div>
          
            <div class="ledger-row py-8 md:pl-8">
              <div class="flex items-center gap-3">
                <span class="num-chip w-8 h-8 rounded-full border flex items-center justify-center shrink-0" style={{borderColor:T.themeblue,color:T.buttonColor}}>03</span>
                <h3 class="font-display font-semibold text-lg">Login explore</h3>
              </div>
              <p class="mt-3 text-sm leading-relaxed text-slate-600">Once the account is verified, you recieve a 200 free credit instantly to your account wallet.</p>
            </div>
          </div>


                <p class="text-xs font-semibold tracking-widest text-slate-400 mt-16">DOWNLOAD OUR APP</p>
                <div class="mt-3 flex flex-wrap gap-3">
                  <a  href="https://beeppeeappmode.web.app/" 
                      target="_blank" 
                      rel="noopener noreferrer" class="flex items-center gap-2 bg-slate-900 text-white px-4 py-2.5 rounded-lg hover:bg-slate-800 transition">
                    <svg class="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M17.05 20.28c-.98.95-2.05.88-3.08.5-1.09-.4-2.09-.42-3.24 0-1.44.53-2.2.36-3.06-.5C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.08zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/></svg>
                    <span class="text-left leading-none">
                      <span class="block text-[10px] text-slate-300">Download on the</span>
                      <span class="block text-sm font-semibold -mt-0.5">App Store</span>
                    </span>
                  </a>
                  
                  <a  href="https://beeppeeappmode.web.app/" 
                      target="_blank" 
                      rel="noopener noreferrer" class="flex items-center gap-2 bg-slate-900 text-white px-4 py-2.5 rounded-lg hover:bg-slate-800 transition">
                    <svg class="w-6 h-6" viewBox="0 0 24 24"><path fill="#00d9ff" d="M3.6 2.3c-.3.3-.5.7-.5 1.2v17c0 .5.2.9.5 1.2l.1.1L13.6 12 3.7 2.2l-.1.1z"/><path fill="#00f076" d="M17 15.4l-3.4-3.4 3.4-3.4 4.1 2.3c.9.5.9 1.7 0 2.2l-4.1 2.3z"/><path fill="#ff3a44" d="M17 8.6l-3.4 3.4L3.6 2.3c.4-.4 1-.5 1.6-.2L17 8.6z"/><path fill="#ffcf00" d="M17 15.4L5.2 21.9c-.6.3-1.2.2-1.6-.2L13.6 12l3.4 3.4z"/></svg>
                    <span class="text-left leading-none">
                      <span class="block text-[10px] text-slate-300">GET IT ON</span>
                      <span class="block text-sm font-semibold -mt-0.5">Google Play</span>
                    </span>
                  </a>
                </div>

        </section>

        <section id="how" class="max-w-6xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-2 gap-14 items-center">

          <div class="relative flex items-center justify-center order-2 md:order-1">
               <img loading='lazy'  className=' w-64 md:w-72 z-50' src={track} />
            <div class="absolute w-72 h-72 md:w-80 md:h-80 rounded-full grain-dot" style={{backgroundColor:"#EAF0FB"}}></div>
          </div>


          <div class="order-1 md:order-2">
            <span class="font-mono text-xs uppercase tracking-[0.2em]" style={{color:""}}>Security</span>
            <h2 class="font-display font-semibold text-3xl md:text-4xl mt-3 leading-tight">How Beeppee app works for you</h2>
            <p class="mt-5 text-slate-600 leading-relaxed">
             Security first, At Beeppee your privacy and security are not just features, they are the foundation of everything we build. 
             We understand that tracking your data requires an immense amount of trust. 
             That is why we design our tools with a strict security-first mindset to keep your personal information safe, private, and under your control.
            </p>
            <a href="#" class="inline-block mt-8 font-mono text-xs uppercase tracking-wider px-6 py-3 border rounded-sm underline-swipe" style={{borderColor:""}}>Read more →</a>
          </div>
       

        </section>

        <section id="needs" class="py-20" style={{background:""}}>
          <div class="max-w-6xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-14 items-center">
          
            <div>
              <h2 class="font-display font-semibold text-3xl md:text-4xl mt-3 leading-tight">Advanced Security Features You Control</h2>
              <p class="mt-5 text-slate-600 leading-relaxed">
                Two-factor authentication (2FA) adding an extra layer of protection to your account login (biometric) 
                Access your app securely using fingerprint scanning. Instant data deletion, purge your tracking history from our servers at any time with one click. 
                Permission management control exactly what device features the app can access. We continuously audit our systems and update our security protocols to stay ahead of modern threats, 
                ensuring your tracking experience remains safe and secure.
              </p>

              <div class="mt-10 grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-8 font-display">
         
                <div class="ledger-row pt-5 flex items-start gap-1">
                  <span class="mt-1 w-2 h-2 rounded-full shrink-0" style={{background:""}}></span>
                  <span class="font-semibold text-base">Upgrade to a paid subscriber to unlock more offers.</span>
                </div>
              </div>

                </div>

            <div class="relative flex items-center justify-center">
              <div class="absolute w-72 h-72 md:w-80 md:h-80 rounded-full" style={{backgroundColor:"#EAF0FB"}}></div>
              <svg viewBox="0 0 300 300" class="relative w-64 md:w-72">
                
                <rect x="110" y="30" width="90" height="180" rx="12" fill="#0B2545"/>
                <rect x="118" y="42" width="74" height="140" rx="4" fill="#1E5FD9"/>
                <circle cx="155" cy="70" r="14" fill="#EAF0FB"/>
                <rect x="130" y="95" width="50" height="8" rx="2" fill="#123B94"/>
                <rect x="130" y="110" width="50" height="8" rx="2" fill="#123B94"/>
                

                <path d="M60 90 L95 78 L95 130 Q95 165 60 180 Q25 165 25 130 L25 78 Z" fill="#FFFFFF" stroke="#0B2545" stroke-width="3"/>
                <circle cx="60" cy="120" r="12" fill="none" stroke="#FF5A36" stroke-width="3"/>
                <line x1="60" y1="128" x2="60" y2="140" stroke="#FF5A36" stroke-width="3" stroke-linecap="round"/>
                
                <circle cx="245" cy="140" r="30" fill="#FFFFFF" stroke="#1E5FD9" stroke-width="3"/>
                <path d="M245 122 a18 18 0 0 1 18 18" fill="none" stroke="#1E5FD9" stroke-width="2.5" stroke-linecap="round"/>
                <path d="M245 130 a10 10 0 0 1 10 10" fill="none" stroke="#1E5FD9" stroke-width="2.5" stroke-linecap="round"/>
                <circle cx="245" cy="140" r="3" fill="#1E5FD9"/>
                
                <circle cx="90" cy="220" r="9" fill="none" stroke="#0B2545" stroke-width="2"/>
                <circle cx="230" cy="235" r="6" fill="none" stroke="#1E5FD9" stroke-width="2"/>
              </svg>
            </div>
          </div>
        </section>

        <section id="trust" class="max-w-6xl mx-auto px-6 md:px-10 py-20 grid md:grid-cols-2 gap-14 items-center">
        

          <div>
            <span class="font-mono text-xs uppercase tracking-[0.2em]" style={{color:"greeen"}}>Why us</span>
            <h2 class="font-display font-semibold text-3xl md:text-4xl mt-3 leading-tight">
              AI powered <br/>
              <span style={{color:"blue"}}>voice prompt</span>
            </h2>
            <p class="mt-5 text-slate-600 leading-relaxed">
              Choosing the right tracking tool is about finding a partner you can trust. At Beeppee, we combine cutting-edge speech to text technology with an uncompromising commitment to your privacy. 
              We design our platform to give you clear, actionable insights without ever compromising your personal safety or data securities.
            </p>
            <div class="mt-8 flex flex-wrap gap-4 px-6 py-3">
            </div>
          </div>
        </section>
        <Footer/>
       </div>
  )
}

export default GetStarted
